(function() {

    'use strict';

    var _         = SAPO.Project.Video._,
        jsonpCORS = SAPO.Utility.jsonpCORS,
        Feat      = SAPO.Project.Video.Features,
        Css       = SAPO.Dom.Css,
        Event     = SAPO.Dom.Event,
        Element   = SAPO.Dom.Element,
        Utils     = SAPO.Utility
    ;

    var plugin = function sv_playlist_plugin(vc, ui, pub) {
        var _this = this;
        this._vc = vc;
        this._els = {
            // Button
            button: null,
            //Dialog
            dialog: null,
            // Wrapper
            wrapper: null,
            //Items array
            items: []
        };

        this._vc.playlist_prev = this.prev.bindObj(this);
        this._vc.playlist_next = this.next.bindObj(this);

        this._ui = ui;
        this._pub = pub;

        // Metadata of the current video
        this._md = {};

        // Playlist response cache
        this.playlistCache = {};
        // Playlist-specific element cache
        this.elementCache = {};
        // JSON Response cache
        this.jsonCache = {};

        this._vc.subscribe('load metadata_changed button_activated ended', undefined, this);


        // create markup

        this.createElements();

        // Set the class names initially
        this.setClassNames();

        Event.observe(_this._els.wrapper, 'click', this._onClick.bindObj(this));

        if( this._vc.getOption('playlist') ) {
            this.loadPlaylist();
        }

        // Exposed API in the video controller
        this._vc.next = this.next.bindObj(this);
        this._vc.prev = this.prev.bindObj(this);
        this._vc.goTo = this.goTo.bindObj(this);
        this.isHD = false;


        this._vc.loadPlaylist = this.loadPlaylist.bindObj(this);
        this._vc.unloadPlaylist = this.unloadPlaylist.bindObj(this);

    };



    plugin.prototype = {
        _name: plugin._name = 'sv_playlist',

        createElements: function playlist_create_elements(){
            var wrapper = document.createElement('ul');

            var dialog = document.createElement('div');
            var prev, next;
            // Prev button
            prev = this._ui.addButton('playlist-prev', 'left');
            this.prevButton = prev;
            Element.insertTop(prev, this._ui._els.left);
            // Next button
            next = this._ui.addButton('playlist-next', 'left');
            this.nextButton = next;

            Element.insertAfter(next, this._ui._els.playPause || prev);

            // Playlist button
            this._els.button = this._ui.addButton('playlist', 'right');
            this._els.button.className += ' sv-playlist';

            // Playlist
            wrapper.className = 'wrapper';
            dialog.className = 'dialog playlist hidden';

            dialog.appendChild(wrapper);
            this._ui._els.aEl.appendChild(dialog);
            this._els.dialog = dialog;
            this._els.wrapper = wrapper;
        },

        loadItems: function playlist_load_items(playNow, nextPage){
            var _this = this;

            // Early return if we're already loading
            if(this.isLoading) {
                return;
            }

            this.loading(true);

            var pageNum = nextPage ? (Math.floor(this.playlist.items.length / this.playlist.itemsPerPage) + 1) : 1;
            var url = this.playlistURL + '?page=' + pageNum;

            this.playNow = playNow;
            this.url = url;

            if(this.jsonCache[url]){
                this.endpointCallback(this.jsonCache[url], true);
            } else {
                jsonpCORS(
                    url,
                    this.endpointCallback.bindObj(this),
                    function(){
                        _this._pub('error', {
                            type:    'NO_SV_PLAYLIST',
                            message: _('noSVPlaylistErrorMsg')
                        });
                    },
                5);
            }
        },

        endpointCallback: function playlist_endpoint_callback(response, isCache){
            if(response && response.items) {
                this.jsonCache[this.url] = response;
                this.playlist.title = response.title;
                this.playlist.totalResults = response.totalResults;
                this.playlist.items = this.playlist.items[response.startIndex] ? this.playlist.items : this.playlist.items.concat(response.items);
                this.buildItems(isCache);

                var itemToPlay = this.playlist.items[this.videoIndex] || this.playlist.items[0];

                if(this.playNow && itemToPlay) {

                    if(this.firstHash && (typeof this.videoIndex === 'undefined')){
                        this.loadItems(this.playNow, true);
                    } else if((this.videoIndex < this.playlist.totalResults) && (this.playlist.items.length <= this.videoIndex)){
                        this.loadItems(this.playNow, true);
                    } else {
                        this.play(itemToPlay, this._vc.getOption('autoplay'), true);
                    }

                }
                this._els.button.setAttribute('title', this.playlist.title);
            }
            this.loading(false);
        },

        loadPlaylist: function playlist_load_playlist(playlistURL, firstHash, startIndex){
            if(this.playlist) {
                if(this.playlistURL === playlistURL) {
                    //return;
                }
                this.unloadPlaylist();
            }
            this.videoIndex = startIndex || this._vc.getOption('startIndex') || 0;
            this.playlistURL = playlistURL || this._vc.getOption('playlist');
            this.playlistURL = this.playlistURL.replace(/https?:/, Feat.pageProtocol());
            this.playlistDomain = /\/\/([^\/]+)/.exec(this.playlistURL)[1];
            this.firstHash = firstHash  || this._vc.getOption('firstHash');
            this.playlist = this.playlistCache[this.playlistURL] || {
                title: '',
                link: null,
                currentIndex: -1,
                totalResults: 0,
                itemsPerPage: 60,
                items: [],
                hashItems : {}
            };
            this._els.items = this.elementCache[this.playlistURL] || [];
            this.loadItems(true);
        },

        unloadPlaylist: function playlist_unload_playlist(noCache){
            if(!noCache){
                this.playlistCache[this.playlistURL] = this.playlist;
                this.elementCache[this.playlistURL] = this._els.items;
            }
            for (var i = 0; i < this._els.items.length; i++) {
                Element.remove(this._els.items[i]);
            }
        },

        loading: function playlist_loading(isLoading){
            this.isLoading = isLoading;
            if(this._els && this._els.loadItems) {
                if(isLoading){
                    Css.addClassName(this._els.loadItems, 'loading');
                } else {
                    Css.removeClassName(this._els.loadItems, 'loading');
                }
            }
        },

        buildItem: function playlist_build_item(item, index){

            var md = this.processMetadata(item, index);
            // Populate the objects with the items metadata. One array and one hash object
            this.playlist.items[md.playlistIndex] = md;
            this.playlist.hashItems[md.hash] = md;

            if(md.hash === this.firstHash) {
                this.videoIndex = md.playlistIndex;
            }

            // Override the related video
            md.relatedVideos = 'none';
            this._pub('cache_metadata', md);

            var listItem = this.createListItem(md);
            this._els.items[md.playlistIndex] = listItem;
            return listItem;
        },

        processMetadata: function playlist_process_metadata(item, index){
            if(item.isPlaylistItem) {
                return item;
            } else {
                // Process the item metadata
                var md = SAPO.Project.Video.processItemMetadata(item, this.playlistDomain);
                // Mark the item as being a playlist item
                md.isPlaylistItem = true;
                // Mark the index of the item in the playlist
                md.playlistIndex = index;
                return md;
            }
        },

        createListItem: function playlist_create_list_item(md){
            var listItem;

            // Check if we have the element in cache and retrieve it if so. If not, create it
            if(this.elementCache && this.elementCache[this.playlistURL] && this.elementCache[this.playlistURL][md.playlistIndex]){
                listItem = this.elementCache[this.playlistURL][md.playlistIndex];
            } else {
                var thumbsUrl = 'http://thumbs.web.sapo.io/?p=' + md.poster + '&W=50&H=28&errorpic=transparent';
                var time = Utils.formatTime(md.duration);
                var img = document.createElement('img');
                var titleText = document.createTextNode(md.title);
                var titleEl = document.createElement('span');
                var durationText = document.createTextNode(time);
                var durationEl = document.createElement('span');

                listItem = document.createElement('li');
                listItem.className = 'row item';
                listItem.setAttribute('data-index', md.playlistIndex);


                img.className = 'item-thumbnail';

                titleEl.className = 'item-title';
                titleEl.appendChild(titleText);

                durationEl.className = 'item-duration';
                durationEl.appendChild(durationText);

                img.style.backgroundImage = 'url(' + thumbsUrl + ')';
                img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
                img.alt = md.title;

                listItem.appendChild(img);
                listItem.appendChild(titleEl);
                listItem.appendChild(durationEl);
            }

            this._els.wrapper.appendChild(listItem);
            return listItem;
        },

        buildItems: function playlist_build_items(isCache){
            var itemElements = this._els.items;
            var numItems = isCache ? 0 :  itemElements.length;
            for(var i = numItems; i < this.playlist.items.length; i++) {
               this.buildItem(this.playlist.items[i], i);
            }
            this.moveloadItems();
        },

        _onClick: function playlist_click_handler(ev){
            var tgtEl = ev.target || ev.srcElement;
            var target = Element.findUpwardsBySelector(tgtEl, '.row');
            if(target) {
                var index = target.getAttribute('data-index');
                if(index) {
                    this.goTo(index);
                } else {
                    this.loadItems(false, true);
                }
            }
        },

        moveloadItems: function playlist_move_load_more(){
            var className = 'row loadmore hidden';
            if(this.playlist.totalResults > this.playlist.items.length) {
                className =  'row loadmore';
            }
            if(!this._els.loadItems) {
                var loadItems = this._els.loadItems = document.createElement('li');
                loadItems.appendChild(document.createTextNode(_('playlistLoadMoreTitle')));
            }

            this._els.loadItems.className = className;

            this._els.wrapper.appendChild(this._els.loadItems);
        },

        play: function playlist_play_item(item, autoPlay, scrollIntoView){
            this.loading(false);
            var loadingUrl = this.isHD ? item.fullURI.replace(/\/mov\/1$/, '/mov/39') : item.fullURI;
            var pl = this.playlist.items,
                idx = item.playlistIndex;
            if( typeof autoPlay === 'undefined' ){
                autoPlay = true;
            }

            if(this.activeItem) {
                Css.removeClassName(this._els.items[this.activeItem.playlistIndex], 'playing');
            }

            this.activeItem = item;
            this.playlist.currentIndex = item.playlistIndex;
            Css.addClassName(this._els.items[item.playlistIndex], 'playing');
            Css.addClassName(this._ui._els.player, 'video-is-new');

            Css.removeClassName(this._ui._els.player, 'no-prev');
            Css.removeClassName(this._ui._els.player, 'no-next');

            this.prevButton.title = pl[idx-1] ? _('playlistPrev') +  pl[idx-1].title : '';
            this.nextButton.title = pl[idx+1] ? _('playlistNext') +  pl[idx+1].title : '';

            if(item.playlistIndex === 0){
                Css.addClassName(this._ui._els.player, 'no-prev');
            } else if ((item.playlistIndex + 1) >= this.playlist.totalResults) {
                Css.addClassName(this._ui._els.player, 'no-next');
            }

            if(scrollIntoView) {
                this._els.dialog.style.display = 'block';
                this._els.items[item.playlistIndex].parentNode.scrollTop = this._els.items[item.playlistIndex].offsetTop - (this._els.items[item.playlistIndex].offsetHeight / 2);
                this._els.dialog.style.display = '';
            }

            this._vc.load(loadingUrl, autoPlay);
        },

        next: function playlist_next(forceAutoplay){
            var autoplay = forceAutoplay || this._vc.isPlaying();

            var nextIndex = this.playlist.currentIndex + 1;
            var nextItem = this.playlist.items[nextIndex];

            if(this.isLoading) {
                return;
            }

            if(!nextItem && this._vc.getOption('loop')){
                nextItem = this.playlist.items[0];
            }

            if(nextItem){
                this.loading(true);
                this.play(nextItem, autoplay, true);
            } else if((this.playlist.totalResults > nextIndex) && this.playlist.items.length >= nextIndex) {
                this.videoIndex = nextIndex;
                this.loadItems(true, true);
            }
        },

        prev: function playlist_prev(){
            var prevItem = this.playlist.items[this.playlist.currentIndex - 1];

            if(this.isLoading) {
                return;
            }

            if(prevItem){
                var wasPlaying = this._vc.isPlaying();
                this.loading(true);
                this.play(prevItem, wasPlaying, true);
            }
        },

        goTo: function playlist_go_to(index){

            if(typeof this.getIndex() === 'undefined') {
                return;
            }

            var itemToPlay = this.playlist.items[index];
            if(itemToPlay) {
                this.play(itemToPlay);
            }
        },

        getIndex: function playlist_get_index(){
            return this._md.playlistIndex || 0;
        },

        hide: function playlist_hide_list(){
            Css.addClassName(this._els.dialog,    'hidden');
            Css.removeClassName(this._els.button, 'active');
        },

        setClassNames: function playlist_set_class_names(){
            var playerElement = this._ui._els.player;
            var classToAdd = ( this._md && this._md.isPlaylistItem ) ? 'is-playlist' : 'not-playlist';
            Css.removeClassName(playerElement, 'is-playlist');
            Css.removeClassName(playerElement, 'not-playlist');
            Css.addClassName(playerElement, classToAdd);
        },

        formatTitle: function playlist_format_title(title, index, totalResults){
            this._ui._els.title.textContent = '(' + (index + 1) + '/' + totalResults + ') ' + title;
        },

        on_metadata_changed: function playlist_on_metadata_changed(mt, md){
            // console.log('on_metadata_changed', md);
            this._md = md;
            if(md.isPlaylistItem) {
                this.formatTitle(md.title, md.playlistIndex, this.playlist.totalResults);
                this.setClassNames();
            }
        },

        on_load: function playlist_on_load() {
            var md = this._md;
            this.loading(false);
            if(md.isPlaylistItem) {
                this.playlist.currentIndex = md.playlistIndex;
                this.formatTitle(md.title, md.playlistIndex, this.playlist.totalResults);
            }
            this.setClassNames();
        },

        on_button_activated: function playlist_on_button_activated(mt, id){
            switch (id) {
                case 'playlist-prev':
                this.prev();
                break;
                case 'playlist-next':
                this.next();
                break;
                case 'playlist':
                var hide = !Css.hasClassName(this._els.dialog, 'hidden');
                Css.setClassName(this._els.dialog,    'hidden',  hide);
                Css.setClassName(this._els.button, 'active', !hide);
                break;
                default:
                if (id.indexOf('quality-') !== 0) { return; }
                this.isHD = this._vc.isHD();
            }
        },

        on_ended: function playlist_on_ended(mt, req){
            if(this._md.isPlaylistItem){
                this.next(!req.isFake);
            }
        }
    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);


})();
